export class ScaConstants {
  static readonly INVALID_CODE_MESSAGE = 'You entered an invalid code.';
  static readonly CODE_IS_REQUIRED = 'Code is required.';
  static readonly CODE_MUST_BE_SIX_DIGITS = 'Code must be 6 digits.';

  static readonly RESEND_COOLDOWN_SECONDS = 30;

  static readonly OTP_CHANNEL_ICONS: Record<string, string> = {
    SMS: 'phone',
    EMAIL: 'email'
  };
  static readonly OTP_CHANNEL_CHECKED_ICONS: Record<string, string> = {
    SMS: '/assets/illustrations/phone-checked.svg',
    EMAIL: '/assets/illustrations/email-checked.svg'
  };
}
